// assets
import {
    LoginOutlined,
    ProfileOutlined,
    MessageFilled,
    CustomerServiceFilled,

} from '@ant-design/icons';

// icons
const icons = {
    LoginOutlined,
    ProfileOutlined,
    MessageFilled,
    CustomerServiceFilled,

};

// ==============================|| MENU ITEMS - EXTRA PAGES ||============================== //

const authentication = {
    id: 'authentication',
    title: 'Authentication',
    type: 'group',
    children: [
        
        {
            id: 'register',
            title: 'Register',
            type: 'item',
            url: '/register',
            icon: icons.ProfileOutlined,
            target: true
        },
        {
            id: 'login',
            title: 'Login',
            type: 'item',
            url: '/login',
            icon: icons.LoginOutlined,
            target: true
        },

    ]
};

export default authentication;
